import { useToast, TOAST_DURATION } from "@/hooks/useToast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            className="p-4 border-none rounded-none shadow-none bg-[#212121]"
            duration={TOAST_DURATION}
          >
            <div className="grid gap-1">
              {title && <ToastTitle className="text-lg text-[#F6F3E7] opacity-100">{title}</ToastTitle>}
              {description && (
                <ToastDescription className="text-base text-[#F6F3E7] opacity-100">
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
